<template>
  <div class="pt20">
    <!-- Your content here -->
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="">
      <span>{{ $t('admin.content.lab.add.back') }}</span>
    </div>
    <a-tabs @change="callback">
      <a-tab-pane key="1" :tab="$t('admin.content.lab.add.tabs.basicInfo')" forceRender="true">
        <Info ref="info" :majorId="majorId" :id="id"></Info>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('admin.content.lab.add.tabs.introduce')" forceRender="true">
        <Introduce ref="introduce"></Introduce>
      </a-tab-pane>
      <a-tab-pane key="3" :tab="$t('admin.content.lab.add.tabs.network')" forceRender="true">
        <Network ref="network"></Network>
      </a-tab-pane>
    </a-tabs>
    <div class="save">
      <a-button type="primary" @click="handleSubmit">{{ $t('admin.content.lab.add.save') }}</a-button>
    </div>
  </div>
</template>

<script>
import Info from './info.vue'
import Introduce from './introduce.vue'
import Network from './network.vue'
import { labSave, labDetail } from '@/api/admin'
export default {
  name: 'LabAdd',
  components: {
    Info,
    Introduce,
    Network
  },
  data() {
    return {
      // Your data here
      majorId: ''
    }
  },
  methods: {
    // Your methods here
    back() {
      this.$router.back()
    },
    callback(key) {
      if (key == 2) {
        this.$refs.introduce.init()
      } else if (key == 3) {
        this.$refs.network.init()
      }
    },
    async handleSubmit() {
      if (!this.$refs.info.handleSubmit()) {
        this.$message.error(this.$t('admin.content.lab.add.messages.fillBasicInfo'))
        return
      } else if (!this.$refs.introduce.handleSubmit()) {
        this.$message.error(this.$t('admin.content.lab.add.messages.fillIntroduce'))
        return
      } else if (!this.$refs.network.handleSubmit()) {
        this.$message.error(this.$t('admin.content.lab.add.messages.fillNetwork'))
        return
      }
      const data = Object.assign({
        collegeId: this.$refs.info.collegeId,
        departmentId: this.$refs.info.departmentId,
        ...this.$refs.info.form.getFieldsValue(),
        majorId: this.$refs.info.majorId,
        intros: this.$refs.introduce.tags,
        networks: this.$refs.network.tags,
        smartEduConfig: {
          resourceCode: this.$refs.info.form.getFieldsValue().resourceCode,
          accessKey: this.$refs.info.form.getFieldsValue().accessKey,
          partnerId: this.$refs.info.form.getFieldsValue().partnerId,
          privateKey: this.$refs.info.form.getFieldsValue().privateKey,
          experimentGoals: this.$refs.info.form.getFieldsValue().experimentGoals,
          experimentContent: this.$refs.info.form.getFieldsValue().experimentContent
        }
      }, {
        id: this.id,
        columnId: this.columnId
      })
      console.log({
        info: this.$refs.info.form.getFieldsValue(),
        introduce: this.$refs.introduce.form.getFieldsValue(),
        network: this.$refs.network.form.getFieldsValue()
      })
      const res = await labSave(data)
      if (res.code === 200) {
        const tip = this.id ? 
          this.$t('admin.content.lab.add.messages.editSuccess') : 
          this.$t('admin.content.lab.add.messages.createSuccess')
        this.$message.success(tip)
        this.$router.back()
      } else {
        this.$message.error(res.message)
      }
    },
    async getLabDetail() {
      const res = await labDetail({ id: this.id })
      if (res.code === 200) {
        this.majorId = res.data.majorId
        console.log('res.data ----->', res.data)
        this.$refs.info.form.setFieldsValue(res.data)
        this.$refs.info.form.setFieldsValue({
          is_examine: Number(res.data.isExamine),
          dataPushType: res.data.dataPushType === '0' ? undefined : res.data.dataPushType
        })
        this.$nextTick(() => {
          this.$refs.info.form.setFieldsValue({
            appId: res.data.ptConfig.appId,
            secretKey: res.data.ptConfig.secretKey,
            resourceCode: res.data.smartEduConfig.resourceCode,
            accessKey: res.data.smartEduConfig.accessKey,
            partnerId: res.data.smartEduConfig.partnerId,
            privateKey: res.data.smartEduConfig.privateKey,
            experimentGoals: res.data.smartEduConfig.experimentGoals,
            experimentContent: res.data.smartEduConfig.experimentContent
          })
        })
        this.$refs.introduce.tags = res.data.intros
        this.$refs.network.tags = res.data.networks

        this.$refs.info.recommendLevelSelect = res.data.recommend
        this.$refs.info.recommend = res.data.recommend > 0

        this.$refs.introduce.init()
        this.$refs.network.init()
      }
    }
  },
  computed: {
    // Your computed properties here
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    this.columnId = this.$route.query.columnId || undefined
    if (this.id) {
      this.getLabDetail()
    }
    // Your mounted hook logic here
  }
}
</script>

<style lang="less" scoped>
/* Your styles here */
/deep/ .ant-tabs-top .ant-tabs-ink-bar-animated{
  display: none !important;
}
/deep/ .ant-tabs-bar{
  border: none;
}
/deep/ .ant-tabs-nav{
  background: #EDF3FA;
  border-radius: 6px;
  .ant-tabs-tab{
    color: #6B738C;
    margin-right: 0;
    padding: 10px 27px;
  }
  .ant-tabs-tab-active{
    color: #FFF;
    background-color: #F27529;
    border-radius: 6px;
  }
}
.save{
  display: flex;
  justify-content: center;
  padding-top: 20px;
}
.back{
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #D6D6D6;
  img{
    height: 10px;
    margin-right: 9px;
  }
}
</style>
